const NodeRSA = require("node-rsa");

export const encryptPayload = (publicKey, data) => {
  const key = new NodeRSA(publicKey, "pkcs8-public-pem");
  const encryptedData = key.encrypt(data, "base64");
  return encryptedData;
};



// WEBPACK FOOTER //
// ./src/helper/encryptPayload.js